import React from "react";

import { Form, InputNumber } from "antd";

const InputNumberField = ({
  state = "Input" /* Input & read-only */,
  label = "",
  name = "",
  rules = [
    /* Default but Mutable*/
    {
      required: true,
      message: `Please input ${label}`,
    },
  ],
}) => {
  return (
    <Form.Item label={label} name={name} rules={rules}>
      <InputNumber
        disabled={state === "Read-only" ? true : false}
        style={{ width: "100%" }}
      />
    </Form.Item>
  );
};

export default InputNumberField;
